// extracted by mini-css-extract-plugin
module.exports = {"hidden":"HideOnScroll_hidden__WjrFE"};